module.exports = __webpack_public_path__ + "img/airbnb.4e5232f1.png";